import React, { useContext, useEffect, useRef } from "react";
import styles from "./form.module.scss";
import upperFirst from "lodash/upperFirst";
import { Form, Formik } from "formik";
import classnames from "classnames";
import { Header } from "../../Header";
import { SubHeader } from "../../SubHeader";
import { PageContext } from "../../Page";
import type { FormPros } from "@whatslly/types/UI-V2/PageBuilderTypes";
import globalStyles from "../../../v2/globalStyles";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FormElement: <T extends Record<string, any> = any>(values: FormPros<T> & { children: React.ReactNode }) => React.JSX.Element = ({
  formikRef,
  initialValues,
  children,
  focusElementNumberFunctionRef,
  enableReinitialize,
  ...props
}) => {
  const { formRef } = useContext(PageContext);
  const formElementRef = useRef<HTMLFormElement | null>(null);
  useEffect(() => {
    if (!formElementRef.current) {
      return;
    }
    (formElementRef.current[0] as HTMLElement)?.focus();
  }, []);

  useEffect(() => {
    if (!focusElementNumberFunctionRef) {
      return;
    }
    focusElementNumberFunctionRef.current = (elementNumber: number) => {
      if (!formElementRef.current) {
        return;
      }
      (formElementRef.current[elementNumber] as HTMLElement)?.focus();
    };
  }, [focusElementNumberFunctionRef]);

  return (
    <>
      {props.header && (
        <Header fontSize={props.header.fontSize ?? "large"} {...props.header}>
          {upperFirst(props.header.text ?? "")}
        </Header>
      )}
      {props.subHeader && <SubHeader {...props.subHeader}>{upperFirst(props.subHeader.text ?? "")}</SubHeader>}
      <Formik
        initialValues={initialValues ?? {}}
        onSubmit={props.onSubmit}
        validate={props.validate || undefined}
        validateOnBlur={false}
        enableReinitialize={enableReinitialize}
        validateOnChange={true}
      >
        {(formikContext) => {
          const { handleSubmit, submitForm } = formikContext;
          if (formikRef) {
            formikRef.current = formikContext;
          }
          if (formRef) {
            formRef.current.submitForm = submitForm;
          }
          return (
            <Form
              className={classnames(styles.form, globalStyles[`pi-${props.paddingInline}`], props.className)}
              onSubmit={handleSubmit}
              ref={formElementRef}
            >
              {children}
            </Form>
          );
        }}
      </Formik>
    </>
  );
};
